import { useMemo } from "react";

interface UsePaginationProps {
  totalCount: number;
  pageSize: number;
  currentPage: number;
}

export const usePagination = ({
  totalCount,
  pageSize,
  currentPage,
}: UsePaginationProps) => {
  const totalPages = Math.ceil(totalCount / pageSize);

  const paginationRange = useMemo(() => {
    const delta = 2;
    const range: (number | string)[] = [];

    for (let i = 1; i <= totalPages; i++) {
      if (
        i === 1 ||
        i === totalPages ||
        (i >= currentPage - delta && i <= currentPage + delta)
      ) {
        range.push(i);
      } else if (range[range.length - 1] !== "...") {
        range.push("...");
      }
    }

    return range;
  }, [totalPages, currentPage]);

  return {
    totalPages,
    paginationRange,
    isFirstPage: currentPage === 1,
    isLastPage: currentPage === totalPages,
  };
};
